<div
  class="w-full py-10 mb-10"
  [ngStyle]="{
    'background-image': backgroundImageUrl(),
    'background-size': 'cover',
    'background-position': 'center',
  }"
>
  <div class="flex items-center p-3 bg-white/60 text-black h-20">
    <div class="ml-10 text-center flex items-center gap-6">
      @if (showNavigation()) {
        <p-button
          icon="pi pi-chevron-left"
          severity="contrast"
          [rounded]="true"
          (onClick)="onPrev()"
        />
      }
      <h2 class="text-2xl m-0 min-w-md text-left">{{ stepTitle() }}</h2>
      @if (showNavigation()) {
        <p-button
          icon="pi pi-chevron-right"
          severity="contrast"
          [rounded]="true"
          (onClick)="onNext()"
        />
      }
    </div>
  </div>
</div>
